const CoverPage = ({ theme, title, subtitle, forName }) => {
    return (
        <div className={`coupon cover ${theme}`}>
            <h1>{title}</h1>
            <p className="subtitle">{subtitle}</p>
            <p className="for">For {forName}</p>
            {theme === "romantic" && <div className="cover-hearts">
                <span>❤</span><span>❤</span><span>❤</span>
            </div>}
        </div>
    );
};

export default CoverPage;
